import {
  SUPERVISOR_ROLE,
  isSupervisorRole,
} from './supervisorRole';

export const REPORT_ROUTE_PERMISSIONS = [
  'administrator',
  SUPERVISOR_ROLE,
  'report_manage',
];

export const buildReportDashboardMenuItem = accountScopedRoute => ({
  name: 'Reports Dashboard',
  label: 'Dashboard',
  icon: 'i-lucide-layout-dashboard',
  to: accountScopedRoute('account_dashboard_reports'),
});

export const canUseReportDrilldown = role => {
  return role === 'administrator' || isSupervisorRole(role);
};

export const filterVisibleReportAgents = ({
  role,
  agents,
  metrics,
}) => {
  if (!isSupervisorRole(role)) return agents;

  const allowedAgentIds = new Set(
    metrics.map(metric => Number(metric.assignee_id))
  );

  return agents.filter(agent => allowedAgentIds.has(Number(agent.id)));
};
